/**
 * Compliance Page Component
 * KYC-centric with placeholder views for training, certificates, audits, etc.
 */

import React from 'react';
import { useAdmin } from '../store/AdminContext';
import './CompliancePage.css';

interface CompliancePageProps {
  view: string;
}

const PLACEHOLDER_VIEWS: Record<string, { title: string; description: string }> = {
  'training-status': {
    title: 'Training Status',
    description: 'Staff training and certification tracking. Coming soon.',
  },
  certificates: {
    title: 'Certificates',
    description: 'Compliance certificates and expiry management. Coming soon.',
  },
  'internal-audits': {
    title: 'Internal Audits',
    description: 'Internal audit logs and findings. Coming soon.',
  },
  'lccp-checklist': {
    title: 'LCCP Checklist',
    description: 'Licence conditions and codes of practice checklist. Coming soon.',
  },
  'limit-requests': {
    title: 'Limit Requests',
    description: 'User limit change requests. Coming soon.',
  },
  'limits-reality': {
    title: 'Limits Reality',
    description: 'Actual vs configured limits comparison. Coming soon.',
  },
  'self-exclusions': {
    title: 'Self Exclusions',
    description: 'Self-exclusion and cooling-off management. Coming soon.',
  },
};

const CompliancePage: React.FC<CompliancePageProps> = ({ view }) => {
  const { setCurrentPage } = useAdmin();

  // Compliance dashboard
  if (view === 'compliance-dashboard') {
    return (
      <div className="compliance-page">
        <div className="page-head">
          <div>
            <h1 className="page-title">Compliance Dashboard</h1>
            <p className="page-sub">KYC and regulatory overview</p>
          </div>
        </div>

        <div className="stats">
          <div className="stat clickable" onClick={() => setCurrentPage('kyc-queue')}>
            <div className="stat-icon orange">📝</div>
            <div className="stat-val">—</div>
            <div className="stat-label">KYC Queue</div>
          </div>
        </div>

        <div className="card">
          <div className="card-head">
            <span className="card-title">Quick Actions</span>
          </div>
          <div className="card-body">
            <button className="btn btn-primary" onClick={() => setCurrentPage('kyc-queue')}>
              View KYC Queue
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Placeholder views
  const placeholder = PLACEHOLDER_VIEWS[view];
  if (placeholder) {
    return (
      <div className="compliance-page">
        <div className="page-head">
          <div>
            <h1 className="page-title">{placeholder.title}</h1>
            <p className="page-sub">Coming soon</p>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 48 }}>
              {placeholder.description}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="compliance-page">
      <div className="page-head">
        <h1 className="page-title">Compliance</h1>
        <p className="page-sub">Compliance management</p>
      </div>
      <div className="card">
        <div className="card-body">
          <p style={{ color: 'var(--text-muted)' }}>Unknown view: {view}</p>
        </div>
      </div>
    </div>
  );
};

export default CompliancePage;
